import { GeoPoint, Timestamp } from 'firebase/firestore';

export enum BusinessCategory {
  FOOD = 'Food & Dining',
  BAR = 'Bars & Lounges',
  RENTAL = 'Rentals',
  BEAUTY = 'Beauty',
  TAXI = 'Taxi',
  ENTERTAINMENT = 'Entertainment',
  SERVICES = 'Services'
}

export const BUSINESS_CATEGORIES: Record<BusinessCategory, { emoji: string; iconName: string }> = {
  [BusinessCategory.FOOD]: { emoji: '🍽️', iconName: 'restaurant' },
  [BusinessCategory.BAR]: { emoji: '🍸', iconName: 'local_bar' },
  [BusinessCategory.RENTAL]: { emoji: '🚗', iconName: 'directions_car' },
  [BusinessCategory.BEAUTY]: { emoji: '💅', iconName: 'content_cut' },
  [BusinessCategory.TAXI]: { emoji: '🚕', iconName: 'local_taxi' },
  [BusinessCategory.ENTERTAINMENT]: { emoji: '🎭', iconName: 'movie' },
  [BusinessCategory.SERVICES]: { emoji: '🔧', iconName: 'build' }
};

export interface Business {
  id?: string;
  name: string;
  description: string;
  category: BusinessCategory;
  location: GeoPoint;
  imageUrl?: string;
  phoneNumber: string;
  createdAt: Date;
  createdBy: string;
  isActive: boolean;
  subscriptionValidUntil: Date;
  likes: number;
  userLikes: string[];
  rating: number;
}

export interface BusinessDocumentData {
  id: string;
  name: string;
  description: string;
  category: string;
  location: {
    latitude: number;
    longitude: number;
  };
  imageUrl?: string;
  phoneNumber: string;
  createdAt: Date | Timestamp;
  createdBy: string;
  isActive: boolean;
  subscriptionValidUntil: Date | Timestamp;
  likes: number;
  userLikes: string[];
  rating: number;
}

export class BusinessModel {
  static fromFirestore(data: BusinessDocumentData): Business {
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      category: data.category as BusinessCategory,
      location: new GeoPoint(data.location.latitude, data.location.longitude),
      imageUrl: data.imageUrl,
      phoneNumber: data.phoneNumber,
      createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate() : new Date(data.createdAt),
      createdBy: data.createdBy,
      isActive: data.isActive,
      subscriptionValidUntil: data.subscriptionValidUntil instanceof Timestamp ? data.subscriptionValidUntil.toDate() : new Date(data.subscriptionValidUntil),
      likes: data.likes,
      userLikes: data.userLikes,
      rating: data.rating
    };
  }

  static toMapPin(business: Business): {
    id: string;
    latitude: number;
    longitude: number;
    type: string;
    title: string;
    description: string;
    createdBy: string;
    createdAt: Date;
    isActive: boolean;
    reportCount: number;
    imageURL?: string;
    hasLiveChat: boolean;
    verificationYes: number;
    verificationNo: number;
  } {
    return {
      id: business.id || '',
      latitude: business.location.latitude,
      longitude: business.location.longitude,
      type: 'business',
      title: business.name,
      description: business.description,
      createdBy: business.createdBy,
      createdAt: business.createdAt,
      isActive: business.isActive && business.subscriptionValidUntil > new Date(),
      reportCount: 0,
      imageURL: business.imageUrl,
      hasLiveChat: false,
      verificationYes: 0,
      verificationNo: 0
    };
  }

  static getCategoryInfo(category: BusinessCategory) {
    return BUSINESS_CATEGORIES[category];
  }
}
